import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  groupHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  leftmostHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '16px',
    rowGap: '8px'
  },
  mhTotalsFormControlLabel: {
    margin: '0px',
    alignItems: 'center',
    transform: 'translateY(-1px)'
  },
  mhTotalsLabel: {
    textTransform: 'none',
    letterSpacing: 0,
    color: 'secondary.main',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium
  },
  groupHeaderText: {
    paddingBottom: '0px',
    letterSpacing: 0,
    color: capitalDesignTokens.foundations.colors.gray1000,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    textTransform: 'capitalize'
  }
});
